var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c(
      "div",
      { staticClass: "item-wrapper" },
      [
        _c("div", { staticClass: "basic-info" }, [
          _c("div", { staticClass: "basic-info-wrapper" }, [
            _c("div", { staticClass: "basic-info-section" }, [
              _c("h2", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.result.FullName))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.result.Title))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-info-section" }),
            _vm._v(" "),
            _c("div", { staticClass: "basic-info-section" }, [
              _c("span", { staticClass: "phone-info" }, [
                _vm._v("\n            Dept "),
                _c("span", { staticClass: "phone-number" }, [
                  _vm._v(_vm._s(_vm.result.Department))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-info-section" }, [
              _c("span", { staticClass: "phone-info" }, [
                _vm._v("\n            Phone\n            "),
                _c("span", { staticClass: "phone-number" }, [
                  _c(
                    "a",
                    { attrs: { href: "tel:" + _vm.result.PhoneNumber } },
                    [_vm._v(_vm._s(_vm.result.PhoneNumber))]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle",
                  value: "accordion-" + this._uid,
                  expression: "'accordion-' + this._uid"
                }
              ],
              staticClass: "item-accordion-toggle",
              attrs: { block: "" }
            },
            [
              _c("span", { staticClass: "item-open lmc-icon icon-angle-up" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "item-closed lmc-icon icon-angle-down"
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "b-collapse",
          {
            attrs: {
              id: "accordion-" + this._uid,
              accordion: "my-accordion",
              role: "tabpanel"
            }
          },
          [
            _c("div", { staticClass: "additional-info" }, [
              _c("div", { staticClass: "info-block" }, [
                _c("div", { staticClass: "info-section photo" }, [
                  _vm.result.Image
                    ? _c("img", {
                        attrs: {
                          src: _vm.result.Image,
                          alt: _vm.result.FullName
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: "/images/contact-placeholder.png",
                          alt: _vm.result.FullName
                        }
                      })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section hide-desktop" }, [
                  _c(
                    "a",
                    {
                      staticClass: "v-card",
                      attrs: {
                        href:
                          "/members/directory/vcard/" + _vm.result.ContactGuid,
                        title: "Download Contact Card"
                      }
                    },
                    [
                      _c("span", { staticClass: "lmc-icon icon-address-card" }),
                      _vm._v(" Download Contact Card ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("h4", [_vm._v("Department")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.result.Department))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("h4", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.result.Email,
                            title: "Email" + _vm.result.FullName
                          }
                        },
                        [_vm._v(_vm._s(_vm.result.Email))]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-block" }, [
                _c("div", { staticClass: "info-section hide-mobile" }, [
                  _c("div", { staticClass: "info-item v-card" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/members/directory/vcard/" +
                            _vm.result.ContactGuid,
                          title: "Download Contact Card"
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "lmc-icon icon-address-card"
                        }),
                        _vm._v(" Download Contact Card ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("h4", [_vm._v("Department")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.result.Department))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("h4", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.result.Email,
                            title: "Email" + _vm.result.FullName
                          }
                        },
                        [_vm._v(_vm._s(_vm.result.Email))]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section" }, [
                  _vm.result.Responsibilities
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("h4", [_vm._v("Responsibilities")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.result.Responsibilities) +
                              "\n              "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.AboutMe
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("h4", [_vm._v("About Me")]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.result.AboutMe) }
                        })
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49b86475", { render: render, staticRenderFns: staticRenderFns })
  }
}